import { useEffect, useState } from 'react';

import { BackgroundProps, BackgroundType } from './types';

export default function Background({ backgroundType: type, children, src }: BackgroundProps) {
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    let interval: number | undefined = undefined;
    const exitInterval: number | undefined = undefined;

    if (type === BackgroundType.ImageSlider && Array.isArray(src)) {
      const images = src;

      interval = setInterval(() => {
        document.querySelector('#background-image-slider')?.classList.remove('fadeOut');
        const newIndex = (imageIndex + 1) % images.length;
        setImageIndex(newIndex);
      }, 6800); // Change image every 5 seconds
    }

    return () => {
      if (interval || exitInterval) {
        clearInterval(interval);
      }
    };
  }, [src, imageIndex, type]);

  if (type === BackgroundType.Image) {
    return (
      <>
        <div
          key={src + type}
          style={{
            backgroundImage: `url(${src})`,
          }}
          className={`bg-[url('${src})'] bg-cover bg-center fixed inset-0 z-0 fadeInOutQuint`}
        />
        <div className="relative z-10">{children}</div>
      </>
    );
  }

  if (type === BackgroundType.Video) {
    return (
      <>
        <video key={src + type} autoPlay loop muted className="w-full h-full object-cover fixed inset-0 z-0 fadeInOutQuint">
          <source src={`/${src}`} type="video/mp4" />
        </video>
        <div className="relative z-10">{children}</div>
      </>
    );
  }

  if (type === BackgroundType.ImageSlider && Array.isArray(src)) {
    return (
      <>
        <div
          key={src[imageIndex] + type}
          id="background-image-slider"
          className="transition-[all] !bg-black align-top w-full min-h-full overflow-hidden m-w-[110%] fadeInOutQuint"
        >
          {src[imageIndex] && (
            <img
              key={src[imageIndex] + type}
              src={`/${src[imageIndex]}`}
              width={'110%'}
              className={'slideAcross absolute top-0 object-cover min-w-[110%]  h-full inset-[0% auto auto 0%] z-[1]'}
            />
          )}
        </div>
        {children}
      </>
    );
  }

  return <div></div>;
}
